import './TextField.css';
import { TextFieldProps } from '../../types';

export const TextField = (props: TextFieldProps) => {
    return (
        <div id="form-group">
            <label htmlFor={props.id}>{props.label}</label>
            <input
                type={props.type}
                id={props.id}
                name={props.name}
                placeholder={props.placeholder}
                required={props.required}
                autoComplete={props.autoComplete}
                onChange={props.onChange}
                className={props.error !== "" ? "border-error" : ""}
                value={props.value}
            />
            {props.error && 
                <span className="error">
                    {props.error}
                </span>
            }
        </div>
    );
};